import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IAuthenticationFeature } from './authentication.feature.state';
import { AuthenticationState } from './authentication.state';

export const getLoginState: MemoizedSelector<IAuthenticationFeature, AuthenticationState> = createFeatureSelector<AuthenticationState>(
  nameof<IAuthenticationFeature>('authenticationFeature')
);

export const getAuthToken = createSelector(getLoginState, (state: AuthenticationState) => state.authToken);

export const getLocationToken = createSelector(getLoginState, (state: AuthenticationState) => state.locationToken);

export const getIsLoading = createSelector(getLoginState, (state: AuthenticationState) => state.isLoading);

export const getFailures = createSelector(getLoginState, (state: AuthenticationState) => state.failures);

export const getAccountDetails = createSelector(getLoginState, (state: AuthenticationState) => state.accountDetails);

export const getEmail = createSelector(getLoginState, (state: AuthenticationState) => state.email);

export const getPersonalDetailsResponse = createSelector(getLoginState, (state: AuthenticationState) => state.personalDetailsSuccess);
export const getChangePasswordResponse = createSelector(getLoginState, (state: AuthenticationState) => state.changePasswordSuccess);

export const getAccountProperties = createSelector(getLoginState, (state: AuthenticationState) => state.accountProperties);
export const getEmailDomains = createSelector(getLoginState, (state: AuthenticationState) => state.emailDomains);

export const getSoftCheckResponse = createSelector(getLoginState, (state: AuthenticationState) => state.softCheckResponse);
export const deactivateAccount = createSelector(getLoginState, (state: AuthenticationState) => state.deactivateAccount);
